import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { getHardcodedPageDSL } from '@beefco/sdk/fake-taxi';
import { getServerJSON } from "../utils/getServerJSON";
import { ScriptSSR } from "../components/ScriptSSR";
var unwrapPageDSL = function unwrapPageDSL(minimalPageDSL) {
  if (!minimalPageDSL) return null;
  return {
    coreDSL: (minimalPageDSL === null || minimalPageDSL === void 0 ? void 0 : minimalPageDSL.coreDSL) || minimalPageDSL || null,
    libraryDSL: (minimalPageDSL === null || minimalPageDSL === void 0 ? void 0 : minimalPageDSL.libraryDSL) || null,
    config: (minimalPageDSL === null || minimalPageDSL === void 0 ? void 0 : minimalPageDSL.config) || null
  };
};

/**
 * На сервере генерирует <script>-тег и кладет в него coreDSL, полученный плагином из отдельного модуля
 * На клиенте подтягивает dsl из тега получив его в dom
 *
 * В случае чистого клиентского рендеринга (CSR-only), запрашивает coreDSL асинхронно
 */
export var HardcodeBoundary = function HardcodeBoundary(_ref) {
  var children = _ref.children,
    pageSlug = _ref.pageSlug,
    externalDSL = _ref.externalDSL;
  var scriptId = "dsl-".concat(pageSlug);
  var _useState = useState(function () {
      // Если через QP передается DSL, то мы всегда его используем
      if (externalDSL) return externalDSL;

      // Если SSR или dev-режим, то берем DSL из бандла, не переживая за tree shaking
      return typeof window === 'undefined' || import.meta.webpackHot ? getHardcodedPageDSL(pageSlug)
      // Иначе, на клиенте, считываем значение переданное бэком в script-тег
      : getServerJSON(scriptId);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    hardcodePageDSL = _useState2[0];
  var _useState3 = useState(unwrapPageDSL(hardcodePageDSL)),
    _useState4 = _slicedToArray(_useState3, 2),
    pageDSL = _useState4[0],
    setPageDSL = _useState4[1];
  var setCoreDSL = useCallback(function (coreDSL) {
    setPageDSL(function (prevState) {
      if (!prevState) return null;
      return _objectSpread(_objectSpread({}, prevState), {}, {
        coreDSL: coreDSL
      });
    });
  }, []);
  var pageDslApi = useMemo(function () {
    return pageDSL ? _objectSpread(_objectSpread({}, pageDSL), {}, {
      setCoreDSL: setCoreDSL
    }) : null;
  }, [pageDSL, setCoreDSL]);
  useEffect(function () {
    if (pageDSL) return;
    console.warn('CSR-only режим не оптимизирован под LowCode, нужно передать dsl в модель');
    // CSR-only без externalDSL, запрашиваем coreDSL и LibraryDSL асинхронно
    getHardcodedPageDSL(pageSlug).then(unwrapPageDSL).then(setPageDSL).catch(console.error);
  }, [pageDSL, pageSlug]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !externalDSL ? /*#__PURE__*/React.createElement(ScriptSSR, {
    id: scriptId
  }, hardcodePageDSL || '') : null, children(pageDslApi));
};